import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'

export enum Store {
  SurLaTable = 'SurLaTable',
  Heb = 'HEB',
  Cvs = 'CVS',
  WinnDixie = 'Winn-Dixie Supermarkets',
  Lowes = 'Lowes',
  Meijer = 'Meijer',
  Michaels = 'Michaels',
  Petco = 'Petco',
  Target = 'Target',
  OfficeDepot = 'Office Depot',
  HarrisTeeter = 'Harris Teeter',
  HyVee = 'HyVee',
  Walgreens = 'Walgreens',
  PetSmart = 'PetSmart',
  Carters = 'Carters',
  Kroger = 'Kroger',
  Publix = 'Publix',
  Safeway = 'Safeway',
}

export type StoreType = {
  id: number
  name: Store
  url: string
  circular_image: string
}

export const shoppingStores = {
  [Store.SurLaTable]: {
    id: 120,
    name: Store.SurLaTable,
    url: 'https://www.shipt.com/stores/sur-la-table',
    circular_image: objectStorageUrl('logo-slt-circle.png'),
  },
  [Store.Cvs]: {
    id: 60,
    name: Store.Cvs,
    url: 'https://www.shipt.com/stores/cvs',
    circular_image: objectStorageUrl('logo-cvs-circle.png'),
  },
  [Store.Heb]: {
    id: 6,
    name: Store.Heb,
    url: 'https://www.shipt.com/stores/h-e-b',
    circular_image: objectStorageUrl('logo-heb-circle.png'),
  },
  [Store.Lowes]: {
    id: 460,
    name: Store.Lowes,
    url: 'https://www.shipt.com/stores/lowes-home-improvement',
    circular_image: objectStorageUrl('logo-lowes-circle.png'),
  },
  [Store.Meijer]: {
    id: 10,
    name: Store.Meijer,
    url: 'https://www.shipt.com/stores/meijer',
    circular_image: objectStorageUrl('logo-meijer-circle.png'),
  },
  [Store.Michaels]: {
    id: 809,
    name: Store.Michaels,
    url: 'https://www.shipt.com/stores',
    circular_image: objectStorageUrl('logo-michaels-circle.png'),
  },
  [Store.OfficeDepot]: {
    id: 122,
    name: Store.OfficeDepot,
    url: 'https://www.shipt.com/stores/office-depot-officemax',
    circular_image: objectStorageUrl('logo-office-depot-circle.png'),
  },
  [Store.Petco]: {
    id: 89,
    name: Store.Petco,
    url: 'https://www.shipt.com/stores/petco',
    circular_image: objectStorageUrl('logo-petco-circle.png'),
  },
  [Store.Target]: {
    id: 27,
    name: Store.Target,
    url: 'https://www.shipt.com/stores/target',
    circular_image: objectStorageUrl('logo-target-circle.png'),
  },
  [Store.HyVee]: {
    id: 52,
    name: Store.HyVee,
    url: 'https://www.shipt.com/stores/hyvee',
    circular_image: objectStorageUrl('logo-hyvee-circle.png'),
  },
  [Store.HarrisTeeter]: {
    id: 6,
    name: Store.HarrisTeeter,
    url: 'https://www.shipt.com/stores/harris-teeter',
    circular_image: objectStorageUrl('logo-harristeeter-circle.png'),
  },
  [Store.WinnDixie]: {
    id: 26,
    name: Store.WinnDixie,
    url: 'https://www.shipt.com/stores/winn-dixie',
    circular_image: objectStorageUrl('logo-winndixie-circle.png'),
  },
  [Store.Walgreens]: {
    id: 188,
    name: Store.Walgreens,
    url: 'https://www.shipt.com/stores/walgreens',
    circular_image: objectStorageUrl('logo-walgreens-circle.png'),
  },
  [Store.PetSmart]: {
    id: 251,
    name: Store.PetSmart,
    url: 'https://www.shipt.com/stores/petsmart',
    circular_image: objectStorageUrl('logo-petsmart-circle.png'),
  },
  [Store.Carters]: {
    id: 241,
    name: Store.Carters,
    url: 'https://www.shipt.com/stores/carters',
    circular_image: objectStorageUrl('logo-carter-circle.png'),
  },
  [Store.Kroger]: {
    id: 2,
    name: Store.Kroger,
    url: 'https://www.shipt.com/stores/kroger',
    circular_image: objectStorageUrl('logo-kroger-circle.png'),
  },
  [Store.Publix]: {
    id: 1,
    name: Store.Publix,
    url: 'https://www.shipt.com/stores/publix',
    circular_image: objectStorageUrl('logo-publix-circle.png'),
  },
  [Store.Safeway]: {
    id: 17,
    name: Store.Safeway,
    url: 'https://www.shipt.com/stores/safeway',
    circular_image: objectStorageUrl('logo-safeway-circle.png'),
  },
} as const satisfies { [key in Store]: StoreType }

export const marketingStores = [
  shoppingStores[Store.Lowes],
  shoppingStores[Store.Cvs],
  shoppingStores[Store.HarrisTeeter],
  shoppingStores[Store.Heb],
  shoppingStores[Store.HyVee],
  shoppingStores[Store.Meijer],
  shoppingStores[Store.OfficeDepot],
  shoppingStores[Store.Petco],
  shoppingStores[Store.Target],
  shoppingStores[Store.Walgreens],
  shoppingStores[Store.WinnDixie],
  shoppingStores[Store.PetSmart],
]
